export default {
  hybrid:  2 ,
  offline: 0,
  online:  1
};
